import React, { useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/Modal'
import { size } from 'lodash'
import './index.scss'

function KillingScenarioModal({ open, close, data }) {
  const { onSubmit, selectedRows, selectAll } = data
  const { t } = useTranslation(['Scenario', 'Wizard'])

  const confirmationMsg = useMemo(() => {
    return selectAll
      ? t('Scenario.ScenarioKill.KILL_ALL_SCENARIOS')
      : size(selectedRows) > 1
      ? t('Scenario.ScenarioKill.KILL_SCENARIOS')
      : t('Scenario.ScenarioKill.KILL_SCENARIO')
  }, [selectedRows, selectAll])

  const onCancel = useCallback(() => {
    onSubmit(selectedRows)
    close()
  }, [close, onSubmit, selectedRows])

  return (
    <Modal
      size='sm'
      className='kill-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t('Scenario.ScenarioKill.KILL_MODAL_TITLE')}
      onRequestSubmit={onCancel}
      primaryButtonText={t('Scenario.ScenarioKill.KILL')}
      secondaryButtonText={t('Common:Cancel')}
      confirmLoadingMessage={t('Common:ScenarioKill.KILL')}
    >
      <h5>{confirmationMsg}</h5>
    </Modal>
  )
}

export default KillingScenarioModal
